export enum CashlessTransactionResult {
  Canceled,
  Completed
}
